import { images } from "assets/themes";

const Loader = ({ loading }) => {
    return (
        <div className="d-flex justify-content-center align-items-center h-100">
            {loading ?
                <div className="w-50 w-md-25 text-center">
                    <img src={images.logo} alt="Bahikhata Logo" />
                    <div className="progress" style={{ height: "5px" }}>
                        <div
                            className="progress-bar bg-app progress-bar-striped progress-bar-animated"
                            role="progressbar"
                            style={{ width: `${loading}%` }}
                            aria-valuenow={loading}
                            aria-valuemin="0"
                            aria-valuemax="100"
                        />
                    </div> </div> : <span className="spinner-grow text-app align-self-center">

                </span>}
        </div>
    )
}

export default Loader;